import DOMPurify from "dompurify";

const render = (el, binding) => {
  if (binding.value === binding.oldValue && el.innerHTML) return;
  el.innerHTML = DOMPurify.sanitize(
    binding.value == null ? "" : String(binding.value),
  );
};

export default {
  bind: render,
  update: render,
};
